import React from "react";
import PrintField from "../../shared/PrintField";
import "./NoticeofDissolution2ndPublication.css";

// stable component type (capture / print mode comes from PrintModeContext)
const InputField = PrintField;

// ฟอร์มประกาศเลิกบริษัท (ครั้งที่ 2)
const Notice2Form = React.forwardRef((props, ref) => {
  return (
    <div className="inv-page">
      <div className="inv-paper" ref={ref}>
        <h2 className="nd-title">ประกาศเลิกบริษัท</h2>

        {/* ชื่อบริษัท จัดกึ่งกลาง */}
        <div className="nd-center-line inv-bold">
          บริษัท
          <InputField className="nd-input long" />
          จำกัด
        </div>

        {/* พารากราฟ 1: ย่อหน้า */}
        <p className="nd-paragraph">
          ขอประกาศให้ทราบโดยทั่วกันว่า ที่ประชุมวิสามัญผู้ถือหุ้น ครั้งที่
          <InputField className="nd-input short" />
          ของบริษัท
          <InputField className="nd-input long" />
          จำกัด ได้มีมติให้เลิกบริษัท ณ วันที่
          <InputField className="nd-input date" />
          เป็นต้นไป
        </p>

        {/* พารากราฟ 2: ย่อหน้า */}
        <p className="nd-paragraph">
          จึงประกาศให้บรรดาลูกหนี้และเจ้าหนี้ทั้งหลายของบริษัท
          <InputField className="nd-input long" />
          จำกัด ได้โปรดติดต่อชำระหนี้ หรือเรียกร้องสิทธิของตน ณ สำนักงานของผู้ชำระบัญชี
          เลขที่
          <InputField className="nd-input" style={{ width: "300px" }} />
          ภายในกำหนด
          <InputField className="nd-input short" />
          วัน นับแต่วันประกาศนี้เป็นต้นไป
        </p>

        {/* วันที่ประกาศ */}
        <div className="nd-date-section">
          ประกาศ ณ วันที่
          <InputField className="nd-input date" />
        </div>

        <div className="inv-footer">
            <div className="inv-footer-text">ขอแสดงความนับถือ</div>
            <div className="inv-sign-block">
              <InputField className="inv-sign-line" optional />
              ( <InputField className="inv-sign-name-field" printFit optional={false} /> )
              <div>ผู้ชำระบัญชี</div>
            </div>
          </div>
      </div>
    </div>
  );
});

export default Notice2Form;
